// Centralized experiment-related constants
export const DEFAULT_EXPERIMENT_WEEKS = 8; // Default duration for new experiments
// A replacement test made from the replacement pickers (Top Productos by machine, "Probar en N máquinas", the
// Machines experiment mode) runs six months by default
export const REPLACEMENT_TEST_WEEKS = 26;


// Margen mínimo de antelación de un cambio. Ningún cliente tiene hoy un ERP que agende cambios
// (todos van por `noop`), así que un experimento puede empezar hoy mismo. El margen de cada ERP
// (`minLeadDays`, p. ej. 3 en backend/src/services/erp-providers/elyte.ts) lo sigue validando el
// backend al aceptar, y su error se muestra tal cual.
export const MIN_ERP_LEAD_DAYS = 0;

/** true si esa fecha de inicio no da el margen que exige el ERP (misma cuenta que el gateway). */
export const startsTooSoonForErp = (value) => {
  if (!value) return false;
  const start = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(start.getTime())) return false;
  const day = (d) => { const c = new Date(d); c.setHours(0, 0, 0, 0); return c.getTime(); };
  return Math.round((day(start) - day(new Date())) / 86400000) < MIN_ERP_LEAD_DAYS;
};

/** Primera fecha de inicio que el ERP aceptaría: se usa como minDate en los calendarios. */
export const earliestErpStartDate = () => {
  const first = new Date();
  first.setHours(0, 0, 0, 0);
  first.setDate(first.getDate() + MIN_ERP_LEAD_DAYS);
  return first;
};
